module.exports = __webpack_public_path__ + "img/2.f163d590.svg";